import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Button from './_button.js'
import LoaderSuspense from './_loader-suspense.js'

export default {
  name: 'BaseEventCard',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          width: '294px',
          height: '158px',
          flexGrow: 0,
          flexShrink: 0,
          flexDirection: 'column',
          padding: '8px',
          boxSizing: 'border-box',
          _mobile_scrollSnapAlign: 'center',
          scrollSnapStop: 'always',
        },
      },
    },
    title: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    clickableArea: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexDirection: 'column',
            flexGrow: 1,
          },
        },
      },
    },
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        showLoaderDelay: 0,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
